import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { NewsService } from '@millionshow/api-client';
import { Icon, SafeHtmlPipe } from '@millionshow/client-libs';
import { injectParams } from 'ngxtension/inject-params';
import { of } from 'rxjs';
import { SeoService } from '../../../services/seo.service';

@Component({
  selector: 'app-donation-detail',
  imports: [CommonModule, RouterLink, Icon, SafeHtmlPipe],
  templateUrl: './donation-detail.page.html',
})
export default class DonationDetailPage {
  private readonly newsService = inject<NewsService>(NewsService);
  private readonly seoService = inject(SeoService);

  readonly id = injectParams('id');

  constructor() {
    effect(() => {
      const data = this.data();

      if (!data) return;

      this.seoService.set({
        title: data.title || '기부사랑 상세',
        description:
          this.stripHtml(data.content || '').slice(0, 140) ||
          '마이스좋은공간 기부사랑 상세 내용을 확인하세요.',
      });
    });
  }

  $data = rxResource({
    params: () => ({ id: this.id() }),
    stream: ({ params }) =>
      params.id
        ? this.newsService.newsControllerFindByIdV1({ id: params.id })
        : of(null),
  });

  readonly data = computed(() => this.$data.value());

  $adjacentNews = rxResource({
    params: () => ({ id: this.id() }),
    stream: ({ params }) =>
      params.id
        ? this.newsService.newsControllerFindAdjacentV1({
            id: params.id,
          })
        : of(null),
  });

  prevNews = computed(() => this.$adjacentNews.value()?.prev ?? null);
  nextNews = computed(() => this.$adjacentNews.value()?.next ?? null);

  stripHtml(html: string): string {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
}
